<template>
  <div class="w-full z-10">
    <Loader :loader="loader" />
    <div class="w-full mt-5" style="height: 600px">
      <v-network-graph
        ref="graph"
        class="graph"
        :configs="configs"
        :nodes="nodes"
        :edges="edges"
        :layouts="layouts"
        :event-handlers="eventHandlers()"
      />
    </div>
  </div>
  <section>
    <Sidebar
      v-model:visible="material.visible"
      :baseZIndex="10000"
      position="full"
    >
      <div>
        <MaterialLoad :data="material.data" />
      </div>
    </Sidebar>
  </section>
</template>

<script lang="ts">
import { getUserFromStorage } from "@/utils/user-store.util";
//@ts-ignore
import * as dagre from "dagre";
import { last, take } from "rxjs";
import * as vNG from "v-network-graph";
import { Edges } from "v-network-graph";
import {
  ForceEdgeDatum,
  ForceLayout,
  ForceNodeDatum
} from "v-network-graph/lib/force-layout";
import { defineComponent, reactive } from "vue";
import { LearningMapService } from "./learning-map.service";
import { nodePosition, svgConfig } from "./learning-map.util";
export default defineComponent({
  name: "learning-map",
  computed: {
    idCourse(): any {
      return this.$route.params.id;
    },
    service(): LearningMapService {
      return new LearningMapService();
    },
  },
  data() {
    return {
      nodeSize: 40,
      loader: true,
      newNodes: [] as any,
      edges: {} as Edges,
      nodes: {} as any,
      layouts: reactive({
        nodes: {},
      }) as any,
      material: {
        data: {
          id: "123",
          name: "Material mock",
          type: "REQUIRED",
          file: {
            name: "File name",
            url: "https://picsum.photos/id/237/500/300",
            type: "png",
          },
        } as any,
        visible: false,
      } as any,
      actualMaterials: new Array(),
      nodesAndTrails: [] as any,
      step: { x: 250, y: 150 },
      family: {} as any,
      userId: "",
      configs: vNG.defineConfigs({
        view: {
          // layoutHandler: new vNG.GridLayout({ grid: 15 }),
          layoutHandler: new ForceLayout({
            positionFixedByDrag: false,
            positionFixedByClickWithAltKey: true,
            createSimulation: (d3, nodes, edges) => {
              const forceLink = d3
                .forceLink<ForceNodeDatum, ForceEdgeDatum>(edges)
                .id((d) => d.id);
              return d3
                .forceSimulation(nodes)
                .force("edge", forceLink.distance(100))
                .force("charge", d3.forceManyBody().strength(-20))
                .force("collide", d3.forceCollide().radius(80).iterations(2))
                .force("center", d3.forceCenter(10));
            },
          }),
          // minZoomLevel: 1,
          // maxZoomLevel: 1,
          panEnabled: true,
          autoPanOnResize: true,
        },
        node: {
          draggable: true,
          normal: {
            type: "circle",
            radius: 32,
            width: 32,
            height: 32,
          },
          hover: {
            type: "circle",
            radius: 32,
            width: 32,
            height: 32,
          },
          label: {
            visible: true,
            fontSize: 12,
            lineHeight: 1.1,
            color: "#000000",
            margin: 20,
            direction: "south",
            directionAutoAdjustment: true,
            background: {
              visible: false,
              color: "#ffffff",
              padding: {
                vertical: 8,
                horizontal: 4,
              },
              borderRadius: 2,
            },
          },
        },
        edge: {
          normal: { color: "gray", width: 1 },
          hover: { color: "#000000", width: 2 },
          marker: {
            source: {
              type: "none",
            },
            target: {
              type: "arrow",
            },
          },
        },
      }),
    };
  },
  props: {
    edge: {
      type: {} as any,
    },
    node: {
      type: {} as any,
    },
  },
  mounted() {
    this.userId = getUserFromStorage()?.id;
    this.getTrailsByCourse();
  },
  unmounted() {
    nodePosition.xActual = null;
  },

  methods: {
    eventHandlers(): vNG.EventHandlers {
      const eventHandlers: vNG.EventHandlers = {
        "node:click": ({ node }) => {
          const filtered = this.nodesAndTrails?.filter(
            (e: any) => e.id == node
          )[0];
          if (filtered?.type == "TRAIL") {
            this.getMaterialsByTrails(filtered?.id);
          }
        },
      };
      return eventHandlers;
    },
    createPoints(): void {
      this.nodesAndTrails.forEach((e) => {
        Object.keys(this.edges).forEach((item) => {
          if (this.edges[item].target == e.id) {
            e.father = this.edges[item].source;
          }
        });
        (e.posX = null),
          (e.posY = null),
          (e.config =
            e.type == "CHAPTER" ? svgConfig.chapter : svgConfig.trail),
          this.createNode(e.id, e.name, e.type);
      });
      setTimeout(() => {
        this.setImagePoints();
      }, 100);
    },
    setImagePoints(): void {
      let statusBefore = null;
      this.nodesAndTrails.forEach((e, i) => {
        const point = document.getElementsByClassName("v-ng-node");
        const iconSvg = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "image"
        );
        iconSvg.setAttribute("x", e.config.x);
        iconSvg.setAttribute("y", e.config.y);
        iconSvg.setAttribute("width", e.config.width);
        iconSvg.setAttribute("heigth", e.config.heigth);
        iconSvg.setAttribute(
          "href",
          e.status ? e.config.imgView : e.config.imgNoView
        );
        
        iconSvg.style.cursor = "pointer";
        point[i].appendChild(iconSvg);

        statusBefore = e.status;
      });
      this.layout("TB");
      this.loader = false;
    },
    createNode(id: string, nodeName: string, type: string) {
      this.nodes[id] = { name: nodeName, type: type };
    },
    layout(direction: "TB" | "LR"): void {
      const graph = new dagre.graphlib.Graph();

      if (
        Object.keys(this.nodes).length <= 1 ||
        Object.keys(this.edges).length == 0
      ) {
        return;
      }

      graph.setGraph({
        rankdir: direction,
        nodesep: this.nodeSize * 2,
        edgesep: this.nodeSize,
        ranksep: this.nodeSize * 2,
      });

      graph.setDefaultEdgeLabel(() => ({}));

      Object.entries(this.nodes).forEach(([nodeId, node]: any) => {
        graph.setNode(nodeId, {
          label: node.type,
          width: this.nodeSize,
          height: this.nodeSize,
        });
      });

      Object.values(this.edges).forEach((edge) => {
        graph.setEdge(edge.source, edge.target);
      });

      dagre.layout(graph);
      this.createBox(graph);
    },
    createBox(graph: dagre.graphlib.Graph): void {
      const box: Record<string, number | undefined> = {};
      graph.nodes().forEach((nodeId: string) => {
        if (nodeId != "null") {
          const x = graph.node(nodeId).x - window.innerWidth / 2 + 100;
          const y =
            graph.node(nodeId).label == "CHAPTER"
              ? -window.innerHeight / 2 + 100
              : graph.node(nodeId).y - window.innerHeight / 2 + 100;
          this.layouts.nodes[nodeId] = { x, y };

          box.top = box.top ? Math.min(box.top, y) : y;
          box.bottom = box.bottom ? Math.max(box.bottom, y) : y;
          box.left = box.left ? Math.min(box.left, x) : x;
          box.right = box.right ? Math.max(box.right, x) : x;
        }
      });
    },
    getTrailsByCourse(): void {
      this.service.trails.subscribe({
        next: (response) => {
          this.nodesAndTrails = response.nodes;
          this.edges = response.edges;
          if (this.nodesAndTrails) {
            this.createPoints();
          }
        },
      });
      // this.service.getTrailsByCourse(this.userId, this.idCourse);
    },
    getMaterialsByTrails(trailId: string): void {
      this.service.materials.pipe(take(2), last()).subscribe({
        next: (response) => {
          this.actualMaterials = response;
          this.getMaterialById(trailId);
        },
      });
      // this.service.getMaterialsByTrails(trailId);
    },
    getMaterialById(trailId: string): void {

      var randomId = this.randomizeIndex(this.actualMaterials?.length);

      if (randomId !== undefined) {
        var actualMaterial = this.actualMaterials[randomId];
        this.service.material.pipe(take(2), last()).subscribe({
          next: (response) => {
            this.material.data = response;
            this.material.visible = true;
          },
        });
        this.service.getMaterialsById(trailId, actualMaterial.id);
      }
    },
    randomizeIndex(length: number): number {
      return Math.floor(Math.random() * length);
    },
  },
});
</script>

